var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18025_34616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4101 15.5893C14.7355 15.9147 15.2632 15.9147 15.5886 15.5893C15.914 15.2638 15.914 14.7362 15.5886 14.4108L11.1779 10L15.5886 5.58928C15.914 5.26384 15.914 4.7362 15.5886 4.41077C15.2632 4.08533 14.7355 4.08533 14.4101 4.41077L9.99935 8.82151L5.58861 4.41076C5.26317 4.08533 4.73553 4.08533 4.41009 4.41076C4.08466 4.7362 4.08466 5.26384 4.41009 5.58928L8.82084 10L4.41009 14.4108C4.08466 14.7362 4.08466 15.2638 4.41009 15.5893C4.73553 15.9147 5.26317 15.9147 5.58861 15.5893L9.99935 11.1785L14.4101 15.5893Z",
    fill: "#E10D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18025_34616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCancel);
export default __webpack_public_path__ + "static/media/iconCancel.7098d9d13907e553aeff7d5e3e09e8cf.svg";
export { ForwardRef as ReactComponent };